export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
// eslint-disable-next-line unicorn/prefer-global-this -- using `typeof window` to safely detect non-browser environments; `globalThis` is always defined
export const IS_SERVER = typeof window === 'undefined'

export const GITHUB_USERNAME = 'UserAAR'

export const SITE_NAME = 'Amil Abdullazada'
export const SITE_KEYWORDS = ['Amil Abdullazada', 'Software Developer', 'Next.js', 'React', 'TypeScript', 'Node.js']

export const SITE_GITHUB_URL = 'https://github.com/UserAAR'
export const SITE_FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61559704170569'
export const SITE_INSTAGRAM_URL = 'https://www.instagram.com/abdullayeff.ar/'
export const SITE_X_URL = 'https://www.linkedin.com/in/aar-amil/'
export const SITE_YOUTUBE_URL = 'https://api.whatsapp.com/send/?phone=994507746585&text=Salam,Amil!'

export const COMMENT_TYPES = ['comment', 'reply'] as const
export const USER_ROLES = ['user', 'admin'] as const
